/* global mainScript */
import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { AnimatePresence, motion } from "framer-motion";

// helper
import parsePerformerDateCopy from "../../helpers/parsePerformerDateCopy";

// style rules
import { Animation } from "../../styles";

const PerformanceCard = ({ toggleSidePanel, performer }) => {
	return (
		<AnimatePresence>
			<Card
				initial={"initial"}
				animate={"animate"}
				exit={"initial"}
				variants={Animation.cards.opacityVariants}
				onClick={() => toggleSidePanel(performer)}
				isRectangle={performer.isRectangle}
			>
				<AspectRatioBox>
					<img
						loading="lazy"
						src={performer.image}
						alt={`${performer.title} image`}
					/>
				</AspectRatioBox>
				<Tags>
					{performer.locationName && 
						(<Tag
							icon={mainScript.assetPath + "images/svg/icons/location-icon.svg"}
							dangerouslySetInnerHTML={{ __html: performer.locationName }}
						/>)}
					{performer.dates.length >= 1 && (
						<Tag
							icon={mainScript.assetPath + "images/svg/icons/calendar-icon.svg"}
						>
							{parsePerformerDateCopy(performer)}
						</Tag>
					)}
				</Tags>
				<Title dangerouslySetInnerHTML={{ __html: performer.title }} />
			</Card>
		</AnimatePresence>
	);
};

export default PerformanceCard;

PerformanceCard.propTypes = {
	toggleSidePanel: PropTypes.func,
	performer: PropTypes.object,
	setSelectedPerformer: PropTypes.func,
};

const Card = styled(motion.li)`
	list-style: none;
	cursor: pointer;

	&:hover {
		img {
			transition: all 0.5s;
			transform: scale(1.1);
		}
	}
	${(props) =>
		props.isRectangle &&
		`
    &:hover {
		img {
			transition: all 0.5s;
			transform: scale(1.05);
		}
	}
  `}
`;

const AspectRatioBox = styled.div`
	position: relative;
	width: 100%;
	display: block;
	overflow: hidden;
	padding-top: calc(302 / 302 * 100%);
	border-radius: 10px;

	> img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center center;
		border-radius: 10px;
		transition: all 0.5s;
	}
`;

const Tags = styled.div`
	padding-top: 1rem;
	display: flex;
	justify-content: space-between;
`;
const Tag = styled.span`
	font-weight: 700;
	font-size: 1.2rem;
	line-height: 1.3rem;
	text-transform: uppercase;
	display: flex;
	gap: 0.47rem;
	align-items: center;

	&::before {
		content: url(${(props) => props.icon});
	}
`;

const Title = styled.h3`
	padding-top: 0.5rem;
	font-size: 1.8rem;
	line-height: 2rem;
`;
